import "./DataCentersCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import Principles from "./sections/Principles";
import Hero from "./sections/Hero";
import Casestudyshowcase from "./sections/Casestudyshowcase";
import Safety from "./sections/Safety";
import Footer from "@/reusable_sections/Footer";
export default function DataCentersCaseStudyPage() {
  return <div>
      <Header />
      
      <Principles />
      <Hero />
      <Casestudyshowcase />
      <Safety />
      <Footer />
    </div>;
}